var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 337,
    viewBox: "0 0 322 337",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.932 55.2391C80.932 55.2391 129.171 94.1106 202.506 21.4271C267.635 -43.1227 320.813 58.7223 321.185 107.494C321.668 170.673 256.056 221.224 287.897 262.721C319.738 304.218 224.752 372.742 173.56 313.439C109.878 239.667 92.6257 299.607 56.3278 299.607C30.2762 299.607 -23.2103 230.868 12.9086 179.728C43.3021 136.695 26.7266 122.413 18.6977 107.494C7.11933 85.9772 34.6182 27.5748 80.932 55.2391Z",
    fill: "#353535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.98 143.625V287.874L53.5115 239.499L54.0146 95.7712L158.98 143.625Z",
    fill: "#484848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.982 143.711V287.961L263.937 241.257V96.2319L158.982 143.711Z",
    fill: "#989898"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.98 143.625L264.449 96.7148L159.808 47.4592L53.5115 95.542L158.98 143.625Z",
    fill: "#565656"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2693 77.5578L198.336 126.12L199.29 161.509L228.687 148.629L227.798 113.016L119.623 65.6369L93.2693 77.5578Z",
    fill: "#484848"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M192.353 195.466C194.018 195.466 195.368 192.849 195.368 189.622C195.368 186.394 194.018 183.778 192.353 183.778C190.687 183.778 189.337 186.394 189.337 189.622C189.337 192.849 190.687 195.466 192.353 195.466Z",
    fill: "#353535"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M240.927 174.45C242.592 174.45 243.942 171.833 243.942 168.606C243.942 165.378 242.592 162.762 240.927 162.762C239.262 162.762 237.912 165.378 237.912 168.606C237.912 171.833 239.262 174.45 240.927 174.45Z",
    fill: "#353535"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M209.824 226.317L207.866 225.51C212.204 213.65 217.644 207.117 224.035 206.091C230.149 205.11 235.298 209.582 237.167 212.084L235.522 213.47C234.229 211.739 229.705 207.437 224.35 208.296C218.835 209.181 213.813 215.413 209.824 226.317Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataIcon);
export default __webpack_public_path__ + "static/media/noData_icon.fbeda205956d22c26a4bd485c14f95b3.svg";
export { ForwardRef as ReactComponent };